//ToDo: Add this to @planet/layers

import MapboxLayer from 'ol/layer/MapboxVector';
import createLayer from '@planet/layers/lib/createLayer';
import {string} from 'prop-types';

const MapboxVectorLayer = createLayer({
  displayName: 'MapboxVectorLayer',

  propTypes: {
    styleUrl: string,
    accessToken: string,
  },

  componentDidMount() {
    this.layer = new MapboxLayer({
      styleUrl: this.props.styleUrl,
      accessToken: this.props.accessToken,
    });

    this.layer
      .getSource()
      .setAttributions([
        '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a>',
        '© <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> ',
      ]);
  },
});

export default MapboxVectorLayer;
